import type { CreateBannerParams, DeleteBannerParams, ListBannersResponse, UpdateBannerParams } from '../types';
import { apiDel, apiGet, apiPost, apiPut } from './api-client';
import { BasicPaginationParams } from './params';

const apiName = 'avaniV2HttpApi';
const path = 'banners';

export const listBanners = async (
  params: BasicPaginationParams = new BasicPaginationParams()
): Promise<ListBannersResponse> => {
  return apiGet(apiName, path, { ...params });
};

export const createBanner = async (body: CreateBannerParams) => {
  return apiPost(apiName, path, body);
};

export const updateBanner = async (params: UpdateBannerParams) => {
  const { bannerId, ...rest } = params;
  return apiPut(apiName, `${path}/${bannerId}`, rest);
};

export const deleteBanner = async (params: DeleteBannerParams) => {
  return apiDel(apiName, `${path}/${params.bannerId}`);
};
